const homeContent = require("static/content/pt/home.json");
const productsContent = require("static/content/pt/products.json");
const resultsContent = require("static/content/pt/results.json");

export default {
  home: homeContent,
  products: productsContent,
  results: resultsContent,
};
